import { post } from './GlobalSerices';
export const saveBasicInfo = async (cookie_id, name, email, phone) => {
    return post('/calls/user/save-basic-info', {
        cookie_id,
        name,
        email,
        phone,
    });
};
